"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DrawType = exports.OrderStatus = exports.Currency = exports.MarketSortType = exports.MarketType = exports.GasStationSpeedType = exports.AuctionStatus = void 0;
var AuctionStatus;
(function (AuctionStatus) {
    AuctionStatus["IN_PROGRESS"] = "IN_PROGRESS";
    AuctionStatus["ENDED"] = "ENDED";
    AuctionStatus["CANCELLED"] = "CANCELLED";
    AuctionStatus["DRAFT"] = "DRAFT";
    AuctionStatus["UNLISTED"] = "UNLISTED";
    AuctionStatus["PENDING_TO_BE_EXECUTED"] = "PENDING_TO_BE_EXECUTED";
    AuctionStatus["PENDING_STRIPE_PAYMENT"] = "PENDING_STRIPE_PAYMENT";
})(AuctionStatus || (exports.AuctionStatus = AuctionStatus = {}));
var GasStationSpeedType;
(function (GasStationSpeedType) {
    GasStationSpeedType["SAFE"] = "SAFE";
    GasStationSpeedType["PROPOSE"] = "PROPOSE";
    GasStationSpeedType["FAST"] = "FAST";
})(GasStationSpeedType || (exports.GasStationSpeedType = GasStationSpeedType = {}));
var MarketType;
(function (MarketType) {
    MarketType["PRIMARY"] = "primary";
    MarketType["SECONDARY"] = "secondary";
    MarketType["FLASH_SALE"] = "flashsale";
    MarketType["PACK"] = "pack";
    MarketType["PRIMARY_EQUIPMENT"] = "primary_equipment";
    MarketType["FLASH_SALE_EQUIPMENT"] = "flashsale_equipment";
    MarketType["SECONDARY_EQUIPMENT"] = "secondary_equipment";
})(MarketType || (exports.MarketType = MarketType = {}));
var MarketSortType;
(function (MarketSortType) {
    MarketSortType["PRICE_ASC"] = "price_asc";
    MarketSortType["PRICE_DESC"] = "price_desc";
    MarketSortType["XP_DESC"] = "xp_desc";
    MarketSortType["XP_ASC"] = "xp_asc";
    MarketSortType["ENDING_SOON"] = "ending_soon";
    MarketSortType["ENDING_DESC"] = "ending_desc";
    MarketSortType["NEWEST"] = "newest";
    MarketSortType["OLDEST"] = "oldest";
    MarketSortType["NAMES_AZ"] = "names_az";
    MarketSortType["NAMES_ZA"] = "names_za";
    MarketSortType["L10_ASC"] = "l10_asc";
    MarketSortType["L10_DESC"] = "l10_desc";
    MarketSortType["TIER_ASC"] = "tier_asc";
    MarketSortType["TIER_DESC"] = "tier_desc";
    MarketSortType["ENTRY_LEVEL_DESC"] = "entry_level_desc";
    MarketSortType["LVL_DESC"] = "lvl_desc";
    MarketSortType["LVL_ASC"] = "lvl_asc";
})(MarketSortType || (exports.MarketSortType = MarketSortType = {}));
var Currency;
(function (Currency) {
    Currency["EUR"] = "eur";
    Currency["USD"] = "usd";
    Currency["USDC"] = "usdc";
    Currency["WMATIC"] = "wmtc";
    Currency["WPOL"] = "wpol";
    Currency["POL"] = "pol";
})(Currency || (exports.Currency = Currency = {}));
var OrderStatus;
(function (OrderStatus) {
    OrderStatus["PENDING"] = "pending";
    OrderStatus["CONFIRMED"] = "confirmed";
    OrderStatus["CANCELLED"] = "cancelled";
})(OrderStatus || (exports.OrderStatus = OrderStatus = {}));
var DrawType;
(function (DrawType) {
    DrawType["MAIN_DRAW"] = "MAIN DRAW";
    DrawType["QUALIFYING"] = "QUALIFYING";
})(DrawType || (exports.DrawType = DrawType = {}));
